import { Fancybox } from "@fancyapps/ui";
import Swiper from 'swiper';
import { Autoplay, Navigation, Pagination } from 'swiper/modules';

window.erpFancybox = Fancybox;
window.erpSwiper = Swiper;

erpSwiper.use([Autoplay, Navigation, Pagination]);